import {Injectable} from '@angular/core';

/**
 * This service creates a query string, based on the provided input. Because
 * ORO uses different delimiters for the queries. Example: firstName~ro finds
 * all first names that have ro in their name. Example number 2: firstName=Roy
 * finds only the first names that are exactly Roy.
 */
@Injectable()
export class QueryParameterService {
  public queryString: string = '';

  /**
   * Creates the query based on the provided parameters.
   *
   * @param parameter Query string parameter
   * @param delimiter Query string delimiter
   * @param value Query string value
   */
  public add(parameter: string, delimiter: string, value: string): void {
    if (this.queryString.length > 0) {
      this.queryString += '&';
    }
    this.queryString += `${parameter}${delimiter}${value}`;
  }

  /**
   * Returns the created query.
   *
   * @returns string Query string
   */
  get getQuery(): string {
    const query = this.queryString;
    this.queryString = '';
    return query;
  }

}
